'use client';

import { useQuery } from '@tanstack/react-query';

import { useWixInstanceContext } from '@/components/Contexts/WixInstanceContext';
import { useApiClient } from '@/hooks/useApiClient';

import type { SessionData } from '@/types/feedback';

export function useSession(params: {
  /** Server-sealed context; the route takes the metasites only from it. */
  sealedContext?: string;
  enabled?: boolean;
}) {
  const apiClient = useApiClient();
  const instance = useWixInstanceContext();
  const { sealedContext, enabled = true } = params;

  return useQuery<SessionData>({
    queryKey: ['session', sealedContext],
    queryFn: async () => {
      const qs = new URLSearchParams({ ctx: sealedContext ?? '' });

      return apiClient
        .get<SessionData>(`api/session?${qs}`)
        .then((r) => r.data);
    },
    enabled: enabled && Boolean(sealedContext) && instance !== null,
  });
}
